export interface HashtagFormValues {
	name: string;
	description: string;
	color: string;
	isPrivate: boolean;
	isFavourite: boolean;
	excludeFromMainFeed: boolean;
	/** Blob reference returned by the upload pipeline (null when no image set). */
	image: string | null;
}

export function formValuesToHashtag(
	data: HashtagFormValues
): Partial<AdminHashtag> {
	return {
		name: data.name,
		description: data.description || null,
		color: data.color,
		isPrivate: data.isPrivate,
		isFavourite: data.isFavourite,
		excludeFromMainFeed: data.excludeFromMainFeed
	};
}
